<template>
  <a :href="linkHref" :target="targetBlank" class="in-page-link" :style="inPageLinkStyles"> <slot /></a>
</template>

<script>
export default {
  name: 'InPageLink',
  props: {
    linkHref: {
      type: String,
      required: true
    },
    targetBlank: {
      type: String,
      default: '_self'
    },
    color: {
      type: String,
      default: '#1370FF'
    }
  },
  computed: {
    inPageLinkStyles () {
      return {
        color: this.color
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.in-page-link {
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
}
</style>
